import * as v from './rules';

/** Mirrors SchoolDtos and the School Master's own constraints. */
export const LIMITS = { name: 200, code: 40 };

export const name = (value) =>
  v.required('School name')(value) ??
  (String(value).trim().length > LIMITS.name ? `School name must be ${LIMITS.name} characters or fewer` : null);

/** Blank is valid: the server allocates a code in the FH-CITY-NNNN shape. */
export const code = (value) => {
  const text = String(value ?? '').trim();
  if (!text) return null;
  if (text.length > LIMITS.code) return `School code must be ${LIMITS.code} characters or fewer`;
  if (!/^[A-Za-z0-9-]+$/.test(text)) return 'Use letters, numbers and hyphens only';
  return null;
};

// City, state and board are chosen from the masters rather than typed, so their only
// rule is that something was chosen — which the form checks beside the picker itself.
export const customerStatus = v.required('Customer status');

export const SERVER_CODES = {
  school_code_taken: 'code',
  school_code_immutable: 'code',
  invalid_city: 'city',
  invalid_board: 'board',
  not_a_sales_rep: 'assignedSalesRepId',
};
